import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Layout = ({ children }) => {
  const location = useLocation();
  const { setError } = useAuth();

  const navigate = useNavigate();

  // const { authUser } = useSelector((state) => state.userStore);

  useEffect(() => {
    setError(null);
  }, [location.pathname]);

  // useEffect(() => {

  //   if (authUser?.status != 1 || authUser?.status != "1") {
  //     localStorage.removeItem("token");
  //     // localStorage.removeItem("email");
  //     localStorage.removeItem("name");
  //     localStorage.removeItem("userType");
  //     navigate("/login");
  //   }
  // }, [JSON.stringify(authUser)]);

  return (
    <>
      <main>{children}</main>
    </>
  );
};

export default Layout;
